import { mapBlocks, platforms } from "@/mocks/chigua";

const guideLinks = [
  { href: "#top", label: "网站首页" },
  { href: "#map", label: "吃瓜地图" },
  { href: "#ranking", label: "热搜总榜" },
  { href: "#events", label: "最新事件" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-200/70">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-6">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl leading-none text-foreground-950">吃瓜入口<span className="text-primary-500">网</span></span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              全网瓜田导航首页。聚合各平台热门入口，标注活跃板块、收录最新事件，把全网热瓜收拾成一张好翻的地图，供你按图索骥、理性围观。
            </p>
            <div className="mt-5 flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-background-50 text-foreground-600 ring-1 ring-background-300"><i className="ri-mail-line" aria-hidden="true"></i></span>
              <span className="text-sm text-foreground-600">tougao@chigua-entrance.com</span>
            </div>
          </div>

          <nav aria-label="站内导航">
            <h3 className="font-heading text-base text-foreground-950">站内直达</h3>
            <ul className="mt-4 flex flex-col gap-2.5">
              {guideLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">{l.label}</a>
                </li>
              ))}
              <li><a href="#faq" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">常见问题</a></li>
              <li><a href="#about" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">关于吃瓜</a></li>
            </ul>
          </nav>

          <nav aria-label="板块分类">
            <h3 className="font-heading text-base text-foreground-950">热门板块</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {mapBlocks.slice(0, 6).map((b) => (
                <li key={b.key}>
                  <a href="#map" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">{b.name}</a>
                </li>
              ))}
            </ul>
            <h3 className="mt-6 font-heading text-base text-foreground-950">平台入口</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2.5">
              {platforms.map((p) => (
                <li key={p.name}>
                  <a href={p.url} target="_blank" rel="nofollow noopener noreferrer" className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600">{p.name}</a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/60 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© {year} 吃瓜入口网 · 本站为热点资讯导航站点，不生产原创内容，尊重并注明各平台来源。</p>
          <p className="whitespace-nowrap text-xs text-foreground-500">理性吃瓜 · 来源可溯 · 保持好奇</p>
        </div>
      </div>
    </footer>
  );
}